export default "__VITE_ASSET__632d90ad__"